import React from 'react';
import { MenuLateral } from '../MenuLateral/MenuLateral'
import { useNavigate } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import './AccesoriosNeo.css';

export function AccesoriosNeo() {

    const navigate = useNavigate();

    const irAPower3600 = () => {
        navigate(`/power3600`);
    };

    const irAPower960 = () => {
        navigate(`/power960`);
    };

    return (
        <>
            <div className="mainContainer">
                <MenuLateral />

                <div className='contenedor'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='tituloAccesoriosNeo'>
                                <h1>Accesorios NEO</h1>
                            </div>

                        </div>

                    </div>

                    <div className='row'>

                        <div className='contenedorCardsAccesoriosNeo'>
                            <div className='row'>
                                <div className='col-xl-6 col-lg-6 col-md-12'>
                                    <Card>
                                        <Card.Img variant="power3600" src={require('../Img/power3600.webp')} onClick={irAPower3600} style={{ cursor: 'pointer' }} alt='Cargador de baterías Power-3600' fetchpriority='high' />
                                        <Card.Body>
                                            <Card.Title className='tituloPower3600'>Cargador de Baterías Power-3600</Card.Title>

                                        </Card.Body>

                                    </Card>
                                </div>
                                <div className='col-xl-6 col-lg-6 col-md-12'>
                                    <Card>
                                        <Card.Img variant="power960" src={require('../Img/power960.webp')} onClick={irAPower960} style={{ cursor: 'pointer' }} alt='Cargador de baterías Power-960' fetchpriority='high' />
                                        <Card.Body>
                                            <Card.Title className='tituloPower960'>Cargador de Baterías Power-960</Card.Title>

                                        </Card.Body>
                                    </Card>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}

